import { useNavigate } from 'features/i18n/router'
import cookie from 'lib/cookie'
import { useEffect } from 'react'

import { logEvent, snowplowEvent } from 'lib/analytics'
import { ROUTE_PATH } from 'lib/paths'
import { useCreateGroupMutation } from 'store/api/yay/group'
import { useCurrentUser } from 'store/api/yay/user'

import GroupSettingsForm from 'features/GroupSettings/GroupSettingsForm'

const CreateGroupModal = () => {
  const navigate = useNavigate()
  const [createGroup] = useCreateGroupMutation()
  const { data: currentUser } = useCurrentUser()

  useEffect(() => {
    snowplowEvent.draft_group()
  }, [])

  return (
    <GroupSettingsForm
      onSubmit={async (data) => {
        createGroup(data).then(async (res) => {
          if ('data' in res) {
            const id = res.data?.group_id

            if (id) {
              logEvent.group_create()

              const createGroupLimit = cookie.createGroupLimit.get() || 0
              cookie.createGroupLimit.set(createGroupLimit + 1, { expires: 1 })

              snowplowEvent.create_group({
                group: {
                  group_id: id,
                  group_category: data.group_category_id.toString(),
                  owner_id: currentUser.id,
                  is_owner: true,
                  is_moderator: false,
                  is_member: true,
                  is_request_pending: false,
                  is_require_age_verify: data.only_verified_age,
                  members: 1,
                  posts: 0,
                },
              })

              await navigate(ROUTE_PATH.GROUP(id), { replace: true })
            }
          }
        })
      }}
    />
  )
}

export default CreateGroupModal
